var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBlackSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.10349 10.2121C2.92905 10.3865 2.92905 10.6693 3.10349 10.8438C3.27793 11.0182 3.56075 11.0182 3.73519 10.8438L6.97271 7.60625L10.2102 10.8438C10.3847 11.0182 10.6675 11.0182 10.8419 10.8438C11.0164 10.6693 11.0164 10.3865 10.8419 10.2121L7.60441 6.97455L10.8418 3.73714C11.0163 3.5627 11.0163 3.27988 10.8418 3.10544C10.6674 2.931 10.3846 2.931 10.2101 3.10544L6.97271 6.34285L3.7353 3.10544C3.56086 2.931 3.27804 2.931 3.1036 3.10544C2.92916 3.27988 2.92916 3.5627 3.1036 3.73714L6.34101 6.97455L3.10349 10.2121Z",
    fill: "#050220"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBlackSmall);
export default __webpack_public_path__ + "static/media/close-black-small.7d60ebbc7a64adfe919816bbd760da03.svg";
export { ForwardRef as ReactComponent };